import { axiosInstance } from './index';

/**
 * Huỷ cả thread option trong chat inquiry (依頼をキャンセル).
 * Viết tay bằng axiosInstance (giống webhookSetting.ts) vì client-axios sinh tự động chưa có endpoint này.
 * BE: POST /inquiry-fee/admin/thread/:groupId/cancel — nếu user đã trả thì hoàn 100% tiền.
 */
const BASE = `${process.env.REACT_APP_API_URL}/inquiry-fee`;

export const inquiryFeeThreadApi = {
  adminCancelThread: (itemMessageGroupId: number) =>
    axiosInstance.post(`${BASE}/admin/thread/${itemMessageGroupId}/cancel`),
};
